import { setCookie } from "nookies";

import {
  REGION_COOKIE_MAX_AGE_SECONDS,
  REGION_COOKIE_NAME,
} from "./region-cookie.constants";

const isHttps = (): boolean => typeof window !== "undefined" && window.location.protocol === "https:";

export const setRegionCookie = (locale: string): void => {
  setCookie(null, REGION_COOKIE_NAME, locale, {
    path: "/",
    maxAge: REGION_COOKIE_MAX_AGE_SECONDS,
    sameSite: "lax",
    secure: isHttps(),
  });
};
